const $ = require('jquery');
const Flickity = require('flickity-imagesloaded');
const Clipboard = require('clipboard');
const modernizr = require('modernizr');
const LazyAllTheThings = require('./lazy-all-things.js');
const HeaderScroll = require('./header-scroll');

window.Flickity = Flickity;

require('./header-scroll.js');
require('flickity-bg-lazyload');
// require('@fancyapps/fancybox');
require('jquery-ui/ui/widgets/slider');
require('jquery-ui-touch-punch');
// require('jquery-ui/ui/widgets/datepicker');
require('jquery-pjax');
require('jquery-visible');
require('jquery-ui/ui/widgets/autocomplete');
require('nodep-date-input-polyfill');
require('bootstrap/dist/js/bootstrap.min.js');

require('bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js');
require('./header-scroll.js');
const attachAddressPicker = require('./nzpost-address');
// require('bootstrap/dist/js/bootstrap.min.js');
// require('bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js');
// V:\spca.chirag.dev6.innovanet.co.nz\node_modules\nodep-date-input-polyfill\nodep-date-input-polyfill.js
require('./nzpost-address');
require('jquery-validation');
require('jquery-date-dropdowns-forked/dist/jquery.date-dropdowns.min.js');

const { Fancybox, Panzoom } = require("@fancyapps/ui");

let headerscroll;

window.dataLayer = window.dataLayer || [];

function ll() {
    const lazy = new LazyAllTheThings(
        $,
        window,
        ['.lazy-src', '.lazy-style', '.lazy-video'],
    );
    $(window).scroll(() => {
        lazy.update();
    });
    lazy.update();
}

window._ll = ll();

function updateCentre() {
    if (!window._Cookies.get('__centre')) {
        $('.js-centre-view').removeAttr('href');
        $('.js-centre-view-hide').hide();
        $('.js-site-header__remove-pref').hide();

        $('.js-centre-view').attr('title', 'Choose a centre');
        $('.js-centre-view').not('.js-centre-view-hide').html('Choose a centre');
        return;
    }

    $('.js-site-header__remove-pref').show();
    $('.js-centre-selected').val(window._Cookies.get('__centre'));
    $('.js-local-centre-prompt').removeClass('active');

    $('.js-centre-view').
    prop('href', '/centre/' + window._Cookies.get('__centre'));
    $('.js-centre-view').
    attr('title',
        'View ' + $('.js-centre-selected option:selected').data('display'));
    $('.js-centre-view').
    not('.js-centre-view-hide').
    html('View ' + $('.js-centre-selected option:selected').data('display'));
    $('.js-centre-view').show();

    if ($('.js-section--newsletter').length) {
        if ($('.js-section--newsletter').find('.validationErrors').length == 0) {
            $("#select-newsletter-nearest-centre").
            val($('.js-centre-selected option:selected').data('display'));
            $(".js-newsletter-centre").
            val($('.js-centre-selected option:selected').data('display'));
        }
    }

    if($('.js-contact-centre').length && $('.js-contact-centre').length > 0) {
        $('.js-contact-centre').val($('.js-centre-selected option:selected').data('display'));
    }
};

// const existingRecaptcha = {};
//
// const recaptchaInit = () => {
//     const allRecaptcha = document.querySelectorAll('.recaptcha');
//     for (let i = 0, c = allRecaptcha.length; i < c; i += 1) {
//         const el = allRecaptcha[i];
//         const id = el.getAttribute('id');
//         const sitekey = el.getAttribute('sitekey');
//
//         if (existingRecaptcha.hasOwnProperty(id) && el.childNodes.length > 0 ) {
//             grecaptcha.reset(existingRecaptcha[id]);
//         } else {
//             existingRecaptcha[id] = grecaptcha.render(el, {
//                 sitekey,
//             });
//         }
//     }
// };
//
// const recaptchaLoad = () => {
//     // load re-captcha
//     const recaptchaScript = document.createElement('script');
//     recaptchaScript.async = true;
//     recaptchaScript.src = 'https://www.google.com/recaptcha/api.js?onload=recaptchaInit&render=explicit';
//     document.querySelector('head').appendChild(recaptchaScript);
// };
//
// window.recaptchaInit = recaptchaInit;

$(document).ready(function ($) {

    ll();
    attachAddressPicker($);

    //for ie9
    if ($('.js-slider-gallery').length && !$('.js-slider-gallery').find('.flickity-viewport').length) {
        $.each($('.js-slider-gallery img'), function (idx, itm) {
            $(itm).attr('src', $(itm).attr('data-flickity-lazyload'));
        });
    }

    //advice autocomplete block
    if ($('.js-advice-autocomplete').length) {
        $('.js-advice-autocomplete').autocomplete({
            source: function (request, response) {
                $.ajax({
                    url: '/advice/autocomplete',
                    dataType: 'json',
                    data: {term: request.term},
                    success: function (data) {
                        response($.map(data, function (item) {
                            return {
                                label: item.title,
                                value: item.slugfragment,
                            };
                        }));
                    },
                });
            },
            minLength: 3,
            select: function (event, ui) {
                event.preventDefault();
                var protocol = location.protocol;
                var slashes = protocol.concat('//');
                var host = slashes.concat(window.location.hostname);
                window.location.href = host + '/advice-and-welfare/article/' +
                    ui.item.value;
            },
            focus: function(event, ui) {
                event.preventDefault(); // or return false;
            },
        }).data('ui-autocomplete')._renderItem = function (ul, item) {
            var newText = String(item.label).replace(
                new RegExp(this.term, 'gi'),
                '<span class=\'ui-menu-item__term\'>$&</span>');

            return $("<li></li>")
                .data('item.autocomplete', item)
                .append('<div>' + newText + '</div>')
                .appendTo(ul);

        };
    }


    window._Cookies = require('js-cookie');

    //attach copy to clipboard...
    const cb = new Clipboard('.js-clipboard-anchor');
    const $note = $('.social-clipboard-note');

    cb.on('success', function () {
        $note.addClass('active');
        setTimeout(function () {
            $note.removeClass('active');
        }, 2000);
    });

    $('.print-link').on('click', function () {
        window.print();
    });

    $(document).on('click', '.js-local-centre-prompt-dismiss', function () {
        window._Cookies.set('__silence', 1, {expires: 7});
        $('.js-local-centre-prompt').removeClass('active');
    });

    $(document).on('change', '.js-centre-selected', function () {
        window._Cookies.set('__centre', $(this).val(), {expires: 365});
        updateCentre();
    });

    $(document).on('click', '.js-site-header__remove-pref', function () {
        $('.js-centre-selected').val('');
        window._Cookies.set('__centre', '', {expires: 365});
        updateCentre();
    });

    if (!window._Cookies.get('__centre') && !window._Cookies.get('__silence')) {
        setTimeout(function () {
            $('.js-local-centre-prompt').addClass('active');
        }, 3000);
    }

    updateCentre();

    if ($('.js-section--newsletter').length) {
        if ($('.js-section--newsletter').data('sent')) {
            $('.js-section--newsletter').find(':text').val('');
            $('.js-section--newsletter').find('.js-card-link').click();
        }
        $('.js-newsletter-centre').val($('.js-section--newsletter select').val());
        $(document).on('change', '.js-section--newsletter select', function () {
            $('.js-newsletter-centre').val($('.js-section--newsletter select').val());
        });
    }

    //load GoogleMap
    if ($('#spca-centre-locations').length &&
        !$('body').hasClass('template--service-list') &&
        !$('body').hasClass('template--centre-detail')) {
        const mapsUrl = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAedo0Ue-eClfghT8QtaWghE7Qxdd_ds0U&callback=initMap';
        const mapsScript = document.createElement('script');
        mapsScript.async = true;
        mapsScript.src = mapsUrl;
        document.querySelector('head').appendChild(mapsScript);
    }

    // attach a header scroll listener
    // not even sure this needs to be a class
    // headerscroll = new HeaderScroll($, '.js-site-header');

    // Hide header on scroll down ----------------------------------------------

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navFixHeight = 400;                                         // height in pixel
    var navbarHeight = $('.js-site-header').outerHeight() + 40;     //+40 due to top position

    $(window).scroll(function(event){
      didScroll = true;
      hasScrolled();
    });

    function hasScrolled() {
      var st = $(this).scrollTop();
      // console.log(st);
      if (st <= navFixHeight) {
        $('.js-site-header').removeClass('header-scroll');
      }
      if(Math.abs(lastScrollTop - st) <= delta)
        return;

      if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        $('.js-site-header').removeClass('nav-down').addClass('header-scroll nav-up');
      } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
          $('.js-site-header').removeClass('nav-up').addClass('nav-down');
        }
      }
      lastScrollTop = st;
    }





    // -------------------------------------------------------------------------------------------------------
    // Toggle link
    // -------------------------------------------------------------------------------------------------------
    $(document).on('click', '.js-toggle', function () {
        $(this).toggleClass('active');
        $($.attr(this, 'href')).toggleClass('active');
        // $('.js-adopt-filter-panel').toggleClass('active');
        return false;
    });




    // -------------------------------------------------------------------------------------------------------
    // Main nav toggle
    // -------------------------------------------------------------------------------------------------------
    $('.js-mainnav-toggle').on('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();

        $(this).toggleClass('active');
        $('.js-mainnav').toggleClass('active');
        $('.js-mainnav-overlay').toggleClass('active');
        $('.js-body').toggleClass('mainnav-active');

    });
    $('.js-mainnav-overlay').on('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        $(this).removeClass('active');
        $('.js-mainnav').removeClass('active');
        $('.js-mainnav-toggle').removeClass('active');
    });


    // -------------------------------------------------------------------------------------------------------
    // On scroll
    // -------------------------------------------------------------------------------------------------------
    $(window).scroll(function(){
        if ($(this).scrollTop() > 10) {
            $('.js-body').addClass('scrolling');

        } else {
            $('.js-body').removeClass('scrolling');
        }
    });


    // -------------------------------------------------------------------------------------------------------
    // Main nav - level 2 toggle
    // -------------------------------------------------------------------------------------------------------
    $(document).on('click', '.js-mainnav-level2-toggle', function (ev) {

        ev.preventDefault();
        ev.stopPropagation();

        const $this = $(this);
        const $nav = $this.parent().find('.dropdown-nav--mainnav');
        $this.toggleClass('active');
        $('.dropdown-nav--mainnav').not($nav).removeClass('active');
        $nav.toggleClass('active');
    });


    // -------------------------------------------------------------------------------------------------------
    // Site search
    // -------------------------------------------------------------------------------------------------------
    $('.js-button-site-search').click(function () {
        $('.js-search-form-panel').addClass('active');
        $('.js-search-field').focus();
        return false;
    });
    $('.js-search-form-panel').click(function () {
        $(this).removeClass('active');
        return false;
    }).on('click', '.js-search-form-fields', function (e) {
        e.stopPropagation();
    });
    $( document ).on( 'keydown', function ( e ) {
        if ( e.keyCode === 27 ) { // ESC
            $('.js-search-form-panel').removeClass('active');
        }
    });


    // -------------------------------------------------------------------------------------------------------
    // Local centre prompt
    // -------------------------------------------------------------------------------------------------------
    $(document).on('click', '.js-local-centre-prompt-dismiss', function () {
        $('.js-local-centre-prompt').removeClass('active');
        return false;
    });

    // $('.js-fancybox').fancybox({
    //     afterShow: function () {
    //         // $( ".js-datepicker" ).datepicker( "refresh" );
    //     }
    // });


    // -------------------------------------------------------------------------------------------------------
    // date picker dropdown
    // -------------------------------------------------------------------------------------------------------
    function refreshDatePicker() {
        // if($(window).width()>1023) {
        $(".js-datepicker").dateDropdowns({
            wrapperClass: "field--dropdown field--date-dropdown js-field--date-dropdown",
            daySuffixes: false
        });

        setTimeout(function(){
            $(".js-field--date-dropdown").find('.day').wrap("<div class='select'></div>");
            $(".js-field--date-dropdown").find('.day > option:first-child').text("Day:");
            $(".js-field--date-dropdown").find(".month").wrap("<div class='select'></div>");
            $(".js-field--date-dropdown").find('.month > option:first-child').text("Month:");
            $(".js-field--date-dropdown").find(".year").wrap("<div class='select'></div>");
            $(".js-field--date-dropdown").find('.year > option:first-child').text("Year:");
        }, 1000);

        $(".js-icon--datepicker").addClass("visuallyhidden");
        // }

    }
    refreshDatePicker();


    // -------------------------------------------------------------------------------------------------------
    // bootstrap date picker
    // -------------------------------------------------------------------------------------------------------

    // function refreshDatePicker() {
    //     $(document).find('.js-datepicker').each(function(){
    //         if($(window).width() > 700) {
    //             $(this).datepicker({
    //                 autoclose: true,
    //                 clearBtn: true,
    //                 format: "yyyy-mm-dd",
    //                 container: $(this).parent("li")
    //             });
    //         } else {
    //             $(this).prop('type', 'date');
    //         }
    //     });
    // }
    // refreshDatePicker();


    // -------------------------------------------------------------------------------------------------------
    // Global accordions
    // -------------------------------------------------------------------------------------------------------
    const allPanels = $('.js-accordion-content').
    not('.js-loaded').
    removeClass('active');

    $(document).on('click', '.js-accordion-heading', function (ev) {
        $('.js-accordion-content').removeClass('active');
        ev.preventDefault();
        ev.stopPropagation();

        const $this = $(this);
        allPanels.removeClass('active');
        $('.js-accordion-heading').not(this).removeClass('active');
        $this.toggleClass('active');
        if ($this.hasClass('active')) {
            $this.parent().find('.js-accordion-content').addClass('active');
        }

    });
    // $('.js-accordion-heading').first().addClass('active');
    // $('.js-accordion-heading').first().parent().find('.js-accordion-content').addClass('active');


    /*
     By Osvaldas Valutis, www.osvaldas.info
     Available for use under the MIT License
     */
    $('[type=file]').each(function () {
        var $input = $(this),
            $label = $input.prev('label'),
            labelVal = $label.html();

        $input.on('change', function (e) {
            var fileName = '';

            if (this.files && this.files.length > 1) {
                fileName = (this.getAttribute('data-multiple-caption') || '').replace(
                    '{count}', this.files.length);
            }
            else if (e.target.value) {
                fileName = e.target.value.split('\\').pop();
            }
            if (fileName) {
                $label.html(fileName);
            }
            else {
                $label.html(labelVal);
            }
        });

        // Firefox bug fix
        $input.on('focus', function () {
            $input.addClass('has-focus');
        }).on('blur', function () {
            $input.removeClass('has-focus');
        });
    });

    // generic PJAX anchor
    if ($.support.pjax) {
        $.pjax.defaults.timeout = 3000;

        $(document).on('click', '.js-pjax-anchor', function (event) {
            $('.js-pjax-anchor').removeClass('active');
            $(this).addClass('active');
            $.pjax.click(event, {
                scrollTo: false,
                container: '.js-pjax-container',
                fragment: '.js-pjax-container'
            })
        });

        $(document).on('click', '.js-pjax-anchor-li', function (event) {
            $('.js-pjax-anchor-li').parent('li').removeClass('active');
            $(this).parent('li').addClass('active');
            $.pjax.click(event, {
                scrollTo: false,
                container: '.js-pjax-container',
                fragment: '.js-pjax-container'
            });
        });



        $('.js-pjax-container').on('pjax:send', function (xhr, options, event) {
            $('.js-pjax-container').addClass('content-loading');
            $('.js-pjax-container-loading').show();
        });

        // reload Flickity on pjax complete
        $('.js-pjax-container').on('pjax:complete', function () {
            if ($(document).find('.js-slider-gallery').length > 0) {
                // var flkty = $$(document).find('.js-slider-gallery').flickity();
                // flkty.flickity('resize');
                var flkty = new Flickity('.js-slider-gallery', {
                    'contain': true,
                    'imagesLoaded': true
                });

                if($('.js-caption').length > 0) {
                    flkty.on( 'change', function(index) {
                        $('.js-caption').html($(flkty.selectedElement).find('img').attr('alt'));
                    });
                }

            }
            $('.js-pjax-container').removeClass('content-loading');
            $('.js-pjax-container-loading').hide();
        });

        $(document).on('submit', '.js-pjax-submit-form', function (event) {
            $.pjax.submit(event, {
                scrollTo: false,
                container: '.js-pjax-form-container',
                fragment: '.js-pjax-form-container',
            });
        });

        $(document).on('submit', '.js-modal-form', function (event) {
            // dont change this variable ie needs it this way
            var serializedArray = $(this).serialize();
            event.preventDefault();

            var container = $(this).closest('.js-modal-form-container');
            $(container).find('div').first().html($('.js-modal-form-spinner').html());

            var elemSelector = container.attr('id')
                ? '#' + container.attr('id')
                : '.js-modal-form-container';

            $.ajax({
                type: 'POST',
                url: $(this).attr('action'),
                beforeSend: function() {
                    $(container).find('div').first().html($('.js-modal-form-spinner').html())
                },
                data: serializedArray, // serializes the form's elements.
                cache: false, // trying this because of ie
                success: function(data)
                {
                    var $response=$(data);
                    var dataToday = $response.find(elemSelector).html();
                    $(elemSelector).html(dataToday);
                    refreshDatePicker();

                    jsValidationFormValidate();
                }
            });

            jsValidationFormValidate();


            event.preventDefault();

            //
            // $.pjax.submit(event, elemSelector, {
            //     fragment: elemSelector,
            // });
        });


    }


    /**
     * Bequest form logic
     */
    if ($('.js-bequest-block').length) {
        updateBequestForm();
        $('.js-bequest-loading').hide();
        $('.js-bequest-container').show();

        $(document).on('change', '.js-contact-type input[type=radio]', function(){
            updateBequestForm();
        });
        /**
         * Bequest form logic ends
         */
    }

    jsValidationFormValidate();


});



function jsValidationFormValidate() {

    $(document).on("keyup", ".js-mobile", function (e) {
        var value = $(this).val();
        var intRegex = /^(((\+64|64)|0)2[0-9]{1})[\s|-]{0,1}(([0-9]{6,8})|(([0-9]{3,5}[\s|-][0-9]{3})|([0-9]{3}[\s|-][0-9]{3,5})|([0-9]{3,4}[\s|-][0-9]{3,4})))$/;
        if (value) {
            if (!isNaN(value) && value.slice(0, 1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0) {
                $(this).parent("li").find(".js-validationErrors").remove();
                $(this).parent("li").find(".validationErrors").remove();
            } else {
                if ($(this).parent("li").find(".validationErrors").length == 0 && $(this).parent("li").find(".js-validationErrors").length == 0) {
                    $(this).parent("li").append('<div class="js-validationErrors"><span id="form_21117_mobilePhone-error" class="jquery-error" style="">Please include your mobile prefix and ensure the number has no spaces (e.g. 0211234567).</span></div>');
                }
            }
        }
    });

    $(document).on("keyup", ".js-just-mobile-validation", function (e) {
        var value = $(this).val();
        var intRegex = /^(((\+64|64)|0)2[0-9]{1})[\s|-]{0,1}(([0-9]{6,8})|(([0-9]{3,5}[\s|-][0-9]{3})|([0-9]{3}[\s|-][0-9]{3,5})|([0-9]{3,4}[\s|-][0-9]{3,4})))$/;
        if (value) {
            if(!isNaN(value) && (value === null || value == '') || (value.slice(0,1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0)) {
                $(this).parent("li").find(".js-validationErrors").remove();
                $(this).parent("li").find(".validationErrors").remove();
            } else {
                if ($(this).parent("li").find(".validationErrors").length == 0 && $(this).parent("li").find(".js-validationErrors").length == 0) {
                    $(this).parent("li").append('<div class="js-validationErrors"><span id="form_21117_mobilePhone-error" class="jquery-error" style="">Please include your mobile prefix and ensure the number has no spaces (e.g. 0211234567).</span></div>');
                }
            }
        }
    });

    $(document).on("keyup", ".js-phoneormobile", function (e) {
        var value = $(this).val();
        var intRegex = /[0-9 -()+]+$/;
        if (value) {
            if(!isNaN(value) && (value === null || value == '') || (value.slice(0,1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0)) {
                $(this).parent("li").find(".js-validationErrors").remove();
                $(this).parent("li").find(".validationErrors").remove();
            } else {
                if ($(this).parent("li").find(".validationErrors").length == 0 && $(this).parent("li").find(".js-validationErrors").length == 0) {
                    $(this).parent("li").append('<div class="js-validationErrors"><span id="form_21117_mobilePhone-error" class="jquery-error" style="">Please include the area code or mobile prefix and ensure the number has no spaces (e.g. 041234567 or 0211234567).</span></div>');
                }
            }
        }
    });

    $(document).on("keyup", ".js-phone", function (e) {
        var value = $(this).val();
        var intRegex = /[0-9 -()+]+$/;
        if (value) {
            if(!isNaN(value) && (value.slice(0,1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0) || value.length == 0) {
                $(this).parent("li").find(".js-validationErrors").remove();
                $(this).parent("li").find(".validationErrors").remove();
            } else {
                if ($(this).parent("li").find(".validationErrors").length == 0 && $(this).parent("li").find(".js-validationErrors").length == 0) {
                    $(this).parent("li").append('<div class="js-validationErrors"><span id="form_21117_mobilePhone-error" class="jquery-error" style="">Please include your area code and ensure the number has no spaces (e.g. 041234567).</span></div>');
                }
            }
        }
    });

    $(document).on("keyup", ".js-email", function (e) {
        var value = $(this).val();
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (value) {
            if (re.test(String(value).toLowerCase())) {
                $(this).parent("li").find(".js-validationErrors").remove();
                $(this).parent("li").find(".validationErrors").remove();
            } else {
                if ($(this).parent("li").find(".validationErrors").length == 0 && $(this).parent("li").find(".js-validationErrors").length == 0) {
                    $(this).parent("li").append('<div class="js-validationErrors"><span id="form_21117_mobilePhone-error" class="jquery-error" style="">This value is not a valid email address.</span></div>');
                }
            }
        }
    });


    // $.validator.addClassRules('js-mobile', {
    //     mobileRule: true
    // });

    // $('.js-validation-form').each( function(){
    //     var form = $(this);
    //     form.validate({
    //         wrapper: "div",
    //         errorClass: 'jquery-error',
    //         errorElement : 'span'
    //     });
    // });


    // /**
    //  * Mobile number validation
    //  */
    //
    // $.validator.addMethod('mobileRule', function(value, element, params) {
    //     if(!value) {
    //         return true;
    //     }
    //     var intRegex = /[0-9 -()+]+$/;
    //     if(!isNaN(value) && value.slice(0,1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0) {
    //         return true;
    //     }
    //     return false;
    // }, "Please include your mobile prefix and ensure the number has no spaces (e.g. 0211234567).");

    // /**
    //  * Just mobile number validation not required
    //  */
    //
    // $.validator.addMethod('justMobileRule', function(value, element, params) {
    //     if(!value) {
    //         return true;
    //     }
    //     var intRegex = /[0-9 -()+]+$/;
    //     if(!isNaN(value) && (value === null || value == '') || (value.slice(0,1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0)) {
    //         return true;
    //     }
    //     return false;
    // }, "Please include your mobile prefix and ensure the number has no spaces (e.g. 0211234567).");
    //
    // /**
    //  * Landline number validation and landlord’s phone number field
    //  */
    // $.validator.addMethod('phoneOrMobileRule', function(value, element, params) {
    //     if(!value) {
    //         return true;
    //     }
    //     var intRegex = /[0-9 -()+]+$/;
    //     if(!isNaN(value) && (value.slice(0,1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0) || value.length == 0) {
    //         return true;
    //     }
    //     return false;
    // }, "Please include the area code or mobile prefix and ensure the number has no spaces (e.g. 041234567 or 0211234567).");
    //
    // /**
    //  * emergency contact field and
    //  */
    // $.validator.addMethod('phoneRule', function(value, element, params) {
    //     if(!value) {
    //         return true;
    //     }
    //     var intRegex = /[0-9 -()+]+$/;
    //     if(!isNaN(value) && (value.slice(0,1) == 0 && intRegex.test(value) && value.indexOf(' ') < 0) || value.length == 0) {
    //         return true;
    //     }
    //     return false;
    // }, "Please include your area code and ensure the number has no spaces (e.g. 041234567).");
    //
    //
    // $( ".js-validation-form input:text, .js-validation-form input:checkbox, .js-validation-form input:radio, .js-validation-form select, .js-validation-form textarea" ).each(function( index ) {
    //     $(this).rules('remove', 'required');
    //     $(this).attr("required", false);
    // });
    //
    // $.validator.addClassRules('js-mobile', {
    //     mobileRule: true
    // });
    //
    // $.validator.addClassRules('js-just-mobile-validation', {
    //     justMobileRule: true
    // });
    //
    // $.validator.addClassRules('js-phoneormobile', {
    //     phoneOrMobileRule: true
    // });
    //
    // $.validator.addClassRules('js-phone', {
    //     phoneRule: true
    // });
    //
    // $.validator.addClassRules('js-email', {
    //     email: true
    // });
}

function disableBequestFormFields() {
    $('.js-input-specific-fields').hide();
    $('.js-input-specific-fields input').prop('disabled', true);
}

function updateBequestForm() {

    disableBequestFormFields();
    if ($('.js-contact-type').find('input:checked').val() == 'By email') {
        disableBequestFormFields();
        $('.js-show-only-for-email').show();
        $('.js-show-only-for-email input').prop('disabled', false);
    } else if ($('.js-contact-type').find('input:checked').val() == 'By phone') {
        disableBequestFormFields();
        $('.js-show-only-for-phone').show();
        $('.js-show-only-for-phone input').prop('disabled', false);
    } else if ($('.js-contact-type').find('input:checked').val() ==
        'Please send me a brochure') {
        disableBequestFormFields();
        $('.js-show-only-for-brochure').show();
        $('.js-show-only-for-brochure input').prop('disabled', false);

    }
}

function initMapDesktop(map) {
    var infoWindows = [];
    var markers = [];
    var resetMarkers = function() {
        for (var idx in markers) {
            var itm = markers[idx];
            itm.setIcon({
                url: '/images/map-marker@2x.png',
                scaledSize: new google.maps.Size(23, 28),
            });
            itm.setAnimation(null);
        }

        for (var idx in infoWindows) {
            var itm = infoWindows[idx];
            itm.close();
        }
    };
    var SnazzyInfoWindow = require('snazzy-info-window');
    $.each($('.js-map-item'), function(idx, itm) {
        var mapMarker = new google.maps.Marker({
            position: {
                lat: parseFloat($(itm).data('lat'), 10),
                lng: parseFloat($(itm).data('lng'), 10),
            },
            map: map,
            icon: {
                url: '/images/map-marker@2x.png',
                scaledSize: new google.maps.Size(23, 28),
            },
            idx: idx,
        });
        mapMarker.addListener('click', function() {
            location.href = $('.js-map-item-' + this.idx).attr('href');
        });
        mapMarker.addListener('mouseover', function() {
            resetMarkers();
            markers[this.idx].setIcon({
                url: '/images/map-marker--selected.png',
                scaledSize: new google.maps.Size(23, 28),
            });
            infoWindows[this.idx].open();
        });
        mapMarker.addListener('mouseout', function() {
            // resetMarkers();
        });

        var content = '<div class="location-map-tooltip">';
        if ($('body').attr('id') == 'page--report-animal-cruelty') {
            content += '<a class="h3 location-map-tooltip-heading" href="#' +
                $(itm).data('slug') + '"><span class="button-txt">' + $(itm).html() +
                '</span></a>';
            content += $(itm).data('cruelty')
                ? '<div class="location-map-tooltip__info location-map-tooltip__info--cruelty"><i class="icon"></i>' +
                $(itm).data('cruelty') + '</div>'
                : '';
            content += '<div class="location-map-tooltip__info location-map-tooltip__info--address"><i class="icon"></i>' +
                $(itm).data('address') + '</div>';
        }
        else {
            content += '<a class="h3 location-map-tooltip-heading" href="#' +
                $(itm).data('slug') + '"><span class="button-txt">' + $(itm).html() +
                '</span></a>';
            content += '<div class="location-map-tooltip__info location-map-tooltip__info--ph"><i class="icon"></i>' +
                $(itm).data('phone') + '</div>';
            content += '<div class="location-map-tooltip__info location-map-tooltip__info--address"><i class="icon"></i>' +
                $(itm).data('address') + '</div>';
        }
        content += '</div>';

        var infoWindow = new SnazzyInfoWindow({
            marker: mapMarker,
            content: content,
            placement: 'right',
            offset: {
                top: '-20px',
                left: '40px',
            },
        });
        markers.push(mapMarker);
        infoWindows.push(infoWindow);

        $(itm).on('mouseenter', function() {
            resetMarkers();
            var idx = $(this).data('idx');
            markers[idx].setIcon({
                url: '/images/map-marker--selected.png',
                scaledSize: new google.maps.Size(23, 28),
            });
            markers[idx].setAnimation(google.maps.Animation.BOUNCE);
        });

        $(itm).on('mouseleave', function() {
            resetMarkers();
        });

    });
}

const mobileAndTabletcheck = () => {
    let check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    }(navigator.userAgent || navigator.vendor || window.opera));
    return check;
};
window.mobileAndTabletcheck = mobileAndTabletcheck;


function initMapMobile(map) {
    var infoWindows = [];
    var markers = [];
    var resetMarkers = function() {
        for (var idx in markers) {
            var itm = markers[idx];
            itm.setIcon({
                url: '/images/map-marker@2x.png',
                scaledSize: new google.maps.Size(23, 28),
            });
            itm.setAnimation(null);
        }

        for (var idx in infoWindows) {
            var itm = infoWindows[idx];
            itm.close();
        }
    };
    var SnazzyInfoWindow = require('snazzy-info-window');map.setZoom
    $.each($('.js-map-item'), function(idx, itm) {
        var mapMarker = new google.maps.Marker({
            position: {
                lat: parseFloat($(itm).data('lat'), 10),
                lng: parseFloat($(itm).data('lng'), 10),
            },
            map: map,
            icon: {
                url: '/images/map-marker@2x.png',
                scaledSize: new google.maps.Size(23, 28),
            },
            idx: idx,
        });
        mapMarker.addListener('click', function() {
            resetMarkers();
            markers[this.idx].setIcon({
                url: '/images/map-marker--selected.png',
                scaledSize: new google.maps.Size(23, 28),
            });
            infoWindows[this.idx].open();
        });

        var content = '<div class="location-map-tooltip">';
        content += '<a class="h3 location-map-tooltip-heading" href="/centre/' +
            $(itm).data('slug') + '"><span class="button-txt">' + $(itm).html() +
            '</span><i class="icon "></i></a>';
        content += '<div class="location-map-tooltip__info location-map-tooltip__info--ph"><i class="icon"></i>' +
            $(itm).data('phone') + '</div>';
        content += '<div class="location-map-tooltip__info location-map-tooltip__info--address"><i class="icon"></i>' +
            $(itm).data('address') + '</div>';
        content += '</div>';

        var infoWindow = new SnazzyInfoWindow({
            marker: mapMarker,
            content: content,
            placement: 'right',
            offset: {
                top: '-20px',
                left: '40px',
            },
        });
        markers.push(mapMarker);
        infoWindows.push(infoWindow);

        $(itm).on('mouseenter', function() {
            resetMarkers();
            var idx = $(this).data('idx');
            markers[idx].setIcon({
                url: '/images/map-marker--selected.png',
                scaledSize: new google.maps.Size(23, 28),
            });
            markers[idx].setAnimation(google.maps.Animation.BOUNCE);
        });

        $(itm).on('mouseleave', function() {
            resetMarkers();
        });

    });
}


function initMap() {
    const nz = {
        lat: -40.785071,
        lng: 172.405249,
    };

    if (!document.getElementById('centre-map')) {
        return;
    }

    const map = new google.maps.Map(document.getElementById('centre-map'), {
        zoom: 5.7,
        center: nz,
        streetViewControl: false,
        mapTypeControl: false,
        scrollwheel: false,
        fullscreenControl: false,
        zoomControl: false,
        disableDefaultUI: true,
        styles: [
            {
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#d7e8f5',
                    },
                ],
            },
            {
                'elementType': 'labels',
                'stylers': [
                    {
                        'visibility': 'off',
                    },
                ],
            },
            {
                'elementType': 'labels.icon',
                'stylers': [
                    {
                        'visibility': 'off',
                    },
                ],
            },
            {
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#616161',
                    },
                ],
            },
            {
                'elementType': 'labels.text.stroke',
                'stylers': [
                    {
                        'color': '#f5f5f5',
                    },
                ],
            },
            {
                'featureType': 'administrative',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'visibility': 'off',
                    },
                ],
            },
            {
                'featureType': 'administrative.land_parcel',
                'stylers': [
                    {
                        'visibility': 'off',
                    },
                ],
            },
            {
                'featureType': 'administrative.land_parcel',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#bdbdbd',
                    },
                ],
            },
            {
                'featureType': 'administrative.neighborhood',
                'stylers': [
                    {
                        'visibility': 'off',
                    },
                ],
            },
            {
                'featureType': 'poi',
                'stylers': [
                    {
                        'visibility': 'off',
                    },
                ],
            },
            {
                'featureType': 'poi',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#eeeeee',
                    },
                ],
            },
            {
                'featureType': 'poi',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#757575',
                    },
                ],
            },
            {
                'featureType': 'poi.park',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#e5e5e5',
                    },
                ],
            },
            {
                'featureType': 'poi.park',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#9e9e9e',
                    },
                ],
            },
            {
                'featureType': 'road',
                'stylers': [
                    {
                        'visibility': 'off',
                    },
                ],
            },
            {
                'featureType': 'road',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#ffffff',
                    },
                ],
            },
            {
                'featureType': 'road',
                'elementType': 'labels.icon',
                'stylers': [
                    {
                        'visibility': 'off',
                    },
                ],
            },
            {
                'featureType': 'road.arterial',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#757575',
                    },
                ],
            },
            {
                'featureType': 'road.highway',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#dadada',
                    },
                ],
            },
            {
                'featureType': 'road.highway',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#616161',
                    },
                ],
            },
            {
                'featureType': 'road.local',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#9e9e9e',
                    },
                ],
            },
            {
                'featureType': 'transit',
                'stylers': [
                    {
                        'visibility': 'off',
                    },
                ],
            },
            {
                'featureType': 'transit.line',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#e5e5e5',
                    },
                ],
            },
            {
                'featureType': 'transit.station',
                'elementType': 'geometry',
                'stylers': [
                    {
                        'color': '#eeeeee',
                    },
                ],
            },
            {
                'featureType': 'water',
                'stylers': [
                    {
                        'color': '#1378c6',
                    },
                ],
            },
        ],

    });

    $(document).on('click', '.js-map-in', function() {
        map.setZoom(map.getZoom() + 1);
    });

    $(document).on('click', '.js-map-out', function() {
        map.setZoom(map.getZoom() - 1);
    });

    if (mobileAndTabletcheck()) {
        initMapMobile(map);
    } else {
        initMapDesktop(map);
    }
};

window.initMap = initMap;


$(window).on('load', function() {
    // init slider
    if ($('.js-slider-gallery').length) {

        var galleryElems = document.querySelectorAll('.js-slider-gallery');

        for ( var i=0, len = galleryElems.length; i < len; i++ ) {

            var galleryElem = galleryElems[i];

            var flkty = new Flickity( galleryElem, {
                contain: true,
                imagesLoaded: true,
                on: {
                    change: function( index ) {
                        $(this.element).parents(".js-gallery-caption").find('.js-caption').html($(this.selectedElement).find('img').attr('alt'));
                    }
                }
            });
        }
    }
});

$(document).ready(function(){


    if ($(".js-carousel").length > 0) {
        var flkty = new Flickity('.js-carousel', {
            'groupCells': true,
            'cellAlign': 'center'
        });


        if (mobileAndTabletcheck()) {
            flkty.on('settle', function (index) {
                $(".js-standard-tab:eq(" + index + ")").trigger('click');
            });
        } else {

            flkty.on('settle', function (index) {
                $(flkty.selectedElement).trigger('click');
            });
        }
    }

    if ($.support.pjax) {
        $.pjax.defaults.timeout = 30000;

        $(document).on('click', '.js-pjax-standard-anchor', function (event) {
            var href = $(this).attr('href');
            $('.js-pjax-standard-anchor').removeClass('current');
            $(this).addClass('current');

            //$.pjax({url: href, container: '#js-pjax-standards-container', fragment: '#js-pjax-standards-container'});

            $.pjax.click(event, {
                scrollTo: false,
                container: '#js-pjax-standards-container',
                fragment: '#js-pjax-standards-container'
            })
        });


        $('#js-pjax-standards-container').on('pjax:complete', function () {

            if ($(document).find('.js-carousel').length > 0) {
                var flkty = new Flickity('.js-carousel', {
                    'groupCells': true,
                    'cellAlign': 'center'
                });

                if (mobileAndTabletcheck()) {
                    flkty.on('settle', function (index) {
                        $(".js-standard-tab:eq(" + index + ")").trigger('click');
                    });
                } else {
                    flkty.on('settle', function (index) {
                        $(flkty.selectedElement).trigger('click');
                    });
                }
            }
        });

    };


    $(document).on('click', '.js-standard-tab', function(){
        var tab_id = $(this).attr('data-tab');

        $('.js-standard-tab .card-link--standards').removeClass('active');
        $('.js-standard-section').removeClass('current');

        $(this).find('.card-link--standards').addClass('active');
        $("#"+tab_id).addClass('current');

    });

    /*$(document).on('click', '.js-certified-tab', function(){
        var tab_id = $(this).attr('data-tab');

        $('.js-certified-tab').removeClass('active');
        $('.js-certified-section').removeClass('current');

        $(this).find('.js-certified-tab').addClass('active');
        $("#"+tab_id).addClass('current');

    });*/

    $(document).on('click', '.about-why-choose__button',function(){
        var tab_id = $(this).attr('data-tab');

        $('.about-why-choose__button').removeClass('current');
        $('.about__tab-content').removeClass('current');

        $(this).addClass('current');
        $("#"+tab_id).addClass('current');
    })

    $(document).on('click', '.js-button',function(){
        $('.standards__tab-content').addClass('content-loading');
        $('.loading-spinner-wrap').addClass('show');
        goToTop('.card-items--products');
        return false;

    })

    $(document).on('click', '.js-tab',function(){
        goToTop('.card-items--products');
        return false;

    })


    $(document).keydown(function(e) {
        switch(e.which) {
            case 37: // left
                if ($(".flickity-prev-next-button.previous").attr('disabled') == 'disabled') {
                    return;
                }
                $(".flickity-prev-next-button.previous").trigger('click');
                break;

            case 38: // up
                break;

            case 39: // right
                if ($(".flickity-prev-next-button.next").attr('disabled') == 'disabled') {
                    return;
                }
                $(".flickity-prev-next-button.next").trigger('click');
                break;

            case 40: // down
                break;

            default: return; // exit this handler for other keys
        }
        e.preventDefault(); // prevent the default action (scroll / move caret)
    });

    // js download file, create ga event
    $(document).on('click','.js-datalayer-trigger', function (ev){
      let eventName = $(this).data("ga-event");
      if(eventName) {
        dataLayer.push({
          'event': eventName
        });
      }
    });
    
    
    
    
    //----------------------------------------------------------------------------
    //Infographic modal
    //----------------------------------------------------------------------------
    const infographicMq = window.matchMedia("(max-width: 1599px)");
    
    Fancybox.bind("[data-infographic]", {
      mainClass: "infographic-modal",
      dragToClose: false,
      Toolbar: {
        display: {
          right: ["close"],
        },
      },
      on: {
        done: (fancybox, slide) => {
            if (infographicMq.matches) {
                if (fancybox.getSlide()) {
                    slide.panzoom.zoomToFull({
                        originX: -3000,
                        originY: -3000
                    });
                }
            }
        },
      },
    });
    
    
    //----------------------------------------------------------------------------
    //Video modal
    //----------------------------------------------------------------------------
    Fancybox.bind('.js-video-modal', {
      mainClass: "video-modal",
      dragToClose: false,
      Toolbar: false,
    });
    
    

});



function goToTop(target){
   /* if ($(target).length >= 1) {
        heightAnchor = $(target).offset().top;
    }
    else {
        heightAnchor = $("a[name=" + target.substr(1, target.length - 1) + "]").offset().top;
    }
    $('html,body').animate({scrollTop: heightAnchor + 1}, 400, 'swing');*/

}




module.exports = $;
